import { createRouter, createWebHistory } from 'vue-router'
import IndexView from '../views/IndexView.vue'
import ProductView from '../views/ProductView.vue'
import ContactUs from '../views/ContactUs.vue'
import NewsDetailsView from '../views/NewsDetailsView.vue'
import BlogView from '../views/BlogView.vue'
import AboutUsView from '../views/AboutUsView.vue'
import ProductDetailsView from '../views/ProductDetailsView.vue'
import BudgetingView from '../views/BudgetingView.vue'
import adminRoutes from '@/admin/router'

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '/index',
    name: 'index',
    component: IndexView
  },
  {
    path: '/product',
    name: 'product',
    component: ProductView
  },
  {
    path: '/product/:category',
    name: 'productCategory',
    component: ProductView,
    props: true
  },
  {
    path: '/product/productId/:productId',
    name: 'productDetails',
    component: ProductDetailsView
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    component: ContactUs
  },
  {
    path: '/blog',
    name: 'blog',
    component: BlogView
  },
  {
    path: '/about',
    name: 'about',
    component: AboutUsView
  },
  {
    path: '/budgeting',
    name: 'budgeting',
    component: BudgetingView
  },
  {
    path: '/news/newsId/:newsId',
    name: 'newsDetails',
    component: NewsDetailsView
  }
].concat(adminRoutes)

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if (to.path.startsWith('/admin') && to.path !== '/admin/login') {
    const token = localStorage.getItem('admin_token');
    if (!token) {
      next('/admin/login');
      return;
    }
  }
  next();
});

export default router
